import showToast from "../foundation/utils/showToast";

export default function withToastContext(Base) {
    return class extends Base {
        showToast = ({ text, source, variant }) => {
            if (!this.toastContainer && (!this.nodeRefs || !this.nodeRefs.base)) {
                return;
            }

            showToast({
                text,
                source,
                variant,
                container: this.toastContainer || this.nodeRefs.base
            });
        }

        getChildContext() {
            let baseContext;
            if (super.getChildContext) {
                baseContext = super.getChildContext();
            }
            return {
                ...baseContext,
                showToast: this.showToast
            };
        }
    };
}
